import { ACCOUNT_DELETION } from "resources/actionTypes";

export const accountDeletionAction = (details, closeAction, resetForm) => {

    return {
        type: ACCOUNT_DELETION.ACCOUNT_DELETION_REQUESTED,
        payload: {userDetails: details, closeAction: closeAction, resetForm: resetForm}
      };
   }